export default __webpack_public_path__ + "static/media/aboutContact.3bb1c862.png";